export class PMOrderOperation {
  public readonly id = `${this.orderNumber}-${this.activityNumber}`;

  public constructor(
    public orderNumber: string,
    public activityNumber: string,
    public workCenter: string,
    public plant: string,
    public workCenterDescription: string,
    public operationShortText: string,
    public internalExternalProcessing: string,
    public vendorNumber: string,
    public vendorName: string,
    public durationOfActivity: string,
    public durationOfActivityUnit: string,
    public objectNumber: string,
    public systemStatus: string,
    public changeDate: string,
    public changeTime: string,
    public earliestStartExecutionDate?: Date,
    public earliestFinishExecutionDate?: Date,
    public latestStartExecutionDate?: Date,
    public latestFinishExecutionDate?: Date,
    public constraintTypeStart?: string,
    public constraintStartDate?: Date,
    public constraintTypeEnd?: string,
    public constraintEndDate?: Date,
    public actualStartExecutionDate?: Date,
    public actualFinishExecutionDate?: Date,
    public forecastFinishDate?: Date,
    public userDate09?: Date
  ) {}
}
